exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.erroralert[data-v-4021f7ef] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  z-index: 233333;\n}\n.erroralert.fade[data-v-4021f7ef] {\n  pointer-events: none;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-4021f7ef","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ErrorAlert.vue
// module id = 367
// module chunks = 1